import React from "react";
import { bannerWrapper } from "./Banner.css";

type BannerType = {
  bannerText: string[];
};
export const Banner = ({ bannerText }: BannerType): JSX.Element => (
  <div className={bannerWrapper}>
    {bannerText.map((text) => (
      // eslint-disable-next-line react/no-danger
      <p key={text} dangerouslySetInnerHTML={{ __html: text }} />
    ))}
  </div>
);
